import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import config from '../../config/config'
import { getToken, checkJapanese } from '../../lib'
import 'react-datepicker/dist/react-datepicker.css'
import CheckIcon from 'material-ui/svg-icons/action/check-circle'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import images from '../../config/images'
import authenticate from '../../layouts/authenticateHOC'
import { connect } from 'react-redux'
import * as actions from '../../layouts/LoggedIn/actions'
import Paper from 'material-ui/Paper'
import TextField from 'material-ui/TextField'
import { FormattedMessage } from 'react-intl'
import MenuItem from 'material-ui/MenuItem'
import SelectField from 'material-ui/SelectField'
import DatePicker from 'material-ui/DatePicker'
import FlatButton from 'material-ui/FlatButton'
import { colorInputField, contract, mode, optionInputText, select, selectarr, webRtc, pcGetUserMedia, mobileGetUserMedia, video_codec, fvdomain_types } from './domainComponent'
import * as userAction from '../Users/actions/'
import UserTable from '../../components/UserTable/Table'
import Snackbar from 'material-ui/Snackbar';
import Modal from '../Users/ListName/Modals';
import EmailModal from '../../components/Seminars/SeminarActions/Modals';
import * as template from './actions'
const APIurl = `${config.URI}/api/v1/fvdomains/`
let domainRoute = `/fvdomain`

const clearPayload = {
  video_end_url: '',
  video_logo_remove: '',
  video_direct_mobile: '',
  admin_guest_url: '',
  video_invite_modal_remove: '',
  video_display_name_remove: '',
  video_webrtc_stats_remove: '',
  video_webrtc_stats_log_enable: '',
  video_fullscreen_remove: '',
  video_mobile_default_backcamera_enable: '',
  video_text_chat_remove: '',
  video_color_bottom_action_button: '',
  video_color_end_call_button: '',
  video_google_analytics: '',
  video_audio_guest_mode: '',
  video_mobile_upper_video_view_size: '',
  video_remote_audio_remove: '',
  video_local_recording_remove: '',
  video_settings_remove: '',
  video_enable_firefox: '',
  video_mirror_enable: '',
  video_header_left_color: '',
  video_header_right_color: '',
  fvlite_auto_trial: '',
  fvlite_auto_trial_time_limit_redirect_url: '',
  video_webrtc_stun_sever: '',
  video_webrtc_stun_sever_port: '',
  video_webrtc_turn_sever: '',
  video_webrtc_turn_sever_port: '',
  video_webrtc_force_turn: '',
}

const clearPCUserMedia = {
  pc_framerate_ideal: '',
  pc_framerate_max: '',
  pc_video_width_min: '',
  pc_video_width_ideal: '',
  pc_video_height_min: '',
  pc_video_height_ideal: '',
}

const clearMobileUserMedia = {
  mobile_framerate_ideal: '',
  mobile_framerate_max: '',
  mobile_video_width_min: '',
  mobile_video_width_ideal: '',
  mobile_video_height_min: '',
  mobile_video_height_ideal: '',
  video_codec: ''
}

class Domain extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      connections: 0,
      description: '',
      trial: true,
      expire: new Date(),
      create: props.location.pathname === `${domainRoute}/create` ? true : false,
      url: '',
      expire_flag: false,
      status: 'expire',
      max_room_num_per_user: 0,
      max_account_num: 0,
      fv_domains_name: '',
      errors: {},
      users: '',
      verify: '',
      video_end_url: '',
      video_logo_remove: '',
      video_direct_mobile: '',
      admin_guest_url: '',
      video_invite_modal_remove: '',
      video_display_name_remove: '',
      video_webrtc_stats_remove: '',
      video_webrtc_stats_log_enable: '',
      video_fullscreen_remove: '',
      video_mobile_default_backcamera_enable: '',
      video_text_chat_remove: '',
      video_color_bottom_action_button: '',
      video_color_end_call_button: '',
      video_google_analytics: '',
      video_audio_guest_mode: '',
      video_mobile_upper_video_view_size: '',
      video_remote_audio_remove: '',
      values: [],
      video_local_recording_remove: '',
      video_settings_remove: '',
      video_enable_firefox: '',
      video_mirror_enable: '',
      video_header_left_color: '',
      video_header_right_color: '',
      fvlite_auto_trial: '',
      fvlite_auto_trial_time_limit_redirect_url: '',
      video_webrtc_stun_sever: '',
      video_webrtc_stun_sever_port: '',
      video_webrtc_turn_sever: '',
      video_webrtc_turn_sever_port: '',
      video_webrtc_force_turn: '',
      open: false,
      user: null,
      snackbarOpen: false,
      snackbarMessage: '',
      listModalOpen: false,
      listModalPurpose: null,
      isEmpty: false,
      singleIconClick: false,
      username: null,
      email: null,
      password: null,
      role: null,
      fvdomain_id: null,
      userId: null,
      expiry_days: '',
      marketing_automation_email: '',
      emailModalOpen: false,
      emailModalPurpose: null,
      fvlite_auto_trial_res: null,
      pc_framerate_ideal: '',
      pc_framerate_max: '',
      pc_video_width_min: '',
      pc_video_width_ideal: '',
      pc_video_height_min: '',
      pc_video_height_ideal: '',
      mobile_framerate_ideal: '',
      mobile_framerate_max: '',
      mobile_video_width_min: '',
      mobile_video_width_ideal: '',
      mobile_video_height_min: '',
      mobile_video_height_ideal: '',
      video_codec: 'VP8',
      fvdomain_type: 'Path Domain',
      campaign: false,
      enable_ipaddress_filter: false,
      enable_webinar: true,
      enable_conference: true
    }
  }

  menuItems(contract) {
    return contract.map((contract) => (
      <MenuItem
        key={contract.value}
        value={contract.value}
        primaryText={contract.name}
        rightIcon={(this.state.trial === contract.value)
          ? (<CheckCircle style={{ fill: '#29B87A' }} />) : (<div />)}
      />
    ))
  }

  menuItemsMode(mode) {
    return mode.map((mode) => (
      <MenuItem
        key={mode.value}
        value={mode.value}
        primaryText={mode.name}
        rightIcon={(this.state.status === mode.value)
          ? (<CheckCircle style={{ fill: '#29B87A' }} />) : (<div />)}
      />
    ))
  }

  options(select, state) {
    return select.map((select) => (
      <MenuItem
        key={select.value}
        value={select.value}
        primaryText={select.label}
        rightIcon={(state === select.value)
          ? (<CheckCircle style={{ fill: '#29B87A' }} />) : (<div />)}
      />
    ))
  }

  adminGuest(select) {
    return select.map((select) => (
      <MenuItem
        key={select.value}
        value={select.value}
        primaryText={select.label}
        rightIcon={(this.state.admin_guest_url === select.value)
          ? (<CheckCircle style={{ fill: '#29B87A' }} />) : (<div />)}
      />
    ))
  }


  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }
  hadleListClick = (e, purpose) => {
    this.setState({ listModalOpen: true, listModalPurpose: purpose });
    this.props.clearErrors()
  }
  getSnackbarDetails = message => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message
    });

  };
  editDetails = (username, email, fvlite_role, fvdomain_id, userId) => {

    this.props.clearErrors()
    this.setState({
      singleIconClick: true,
      username,
      email,
      fvlite_role,
      fvdomain_id,
      userId,
      listModalPurpose: 'editUser',
      listModalOpen: true
    });
  };
  handleClose = () => {

    this.setState({ open: false });
  }

  handleListModalClose = () => this.setState({ listModalOpen: false });

  handleDeleteTouch = (e, message, id, fvdomain_id) => {
    const token = getToken();
    this.setState({
      singleIconClick: true,
      selectedRows: [],
      snackbarOpen: true,
      snackbarMessage: message
    });
    e.target.style.fill = e.target.style.fill === 'red' ? '#afb8c5' : 'red';
    this.props.deleteUser(token, id, fvdomain_id);
  };


  handleGenApiTokenTouch = (userID, fvdomain_id) => {
    const token = getToken();
    this.props.genApiTokenUser(token, userID, fvdomain_id);
  }

  handleRevokeApiTokenTouch = (userID, fvdomain_id) => {
    const token = getToken();
    this.props.revokeApiTokenUser(token, userID, fvdomain_id);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.success) {
      setTimeout(() => this.handleListModalClose()
        , 2000)
    }
    if (newProps.domains) {
      if (!this.state.create) {
        if (newProps.domains.data.status && newProps.domains.data.status === 'success') {
          let { expire_flag, users, verify } = newProps.domains.data.data
          this.setState({
            ...newProps.domains.data.data.domain,
            expire: new Date(newProps.domains.data.data.domain.expire),
            expire_flag, users, verify,
            fvlite_auto_trial_res: newProps.domains.data.data.domain.fvlite_auto_trial
          })
        }
      }
    }
  }
  async componentDidMount() {
    const token = getToken();
    if (!this.state.create) {
      this.props.getExpiredUserDefaultTemplate(this.props.match.params.id)
      this.props.expiredMADefault(this.props.match.params.id)
      this.props.MASignupEmailTemplate(this.props.match.params.id)
    }
    this.props.getSingleDomainData(this.props.match.params.id);
    if (this.props.match.params.id) {
      this.props.fetchUserList(token, this.props.match.params.id);
      this.setState({
        fvdomain_id: this.props.match.params.id
      })
    }
    const sessionToken = sessionStorage.getItem('authToken')
    const localToken = localStorage.getItem('authToken')
    if (sessionToken === null && localToken === null) {
      this.props.history.push('/login')
    }
  }

  validate = (data) => {
    const errors = {}
    if (!this.state.name || this.state.name.length === 0) errors.name = '入力してください'

    if (!this.state.fv_domains_name || this.state.fv_domains_name.length === 0) errors.fv_domains_name = '入力してください'
    if (!this.state.fv_domains_name.match(/^[a-z0-9-]*$/)) errors.fv_domains_name = '小文字とハイフンのみ使用可能です。'
    if (!this.state.max_account_num || this.state.max_account_num <= 0) errors.max_account_num = '1以上を入力してください'
    if (!this.state.max_room_num_per_user || this.state.max_room_num_per_user <= 0) errors.max_room_num_per_user = '1以上を入力してください'
    if (this.state.video_mobile_upper_video_view_size > 100) errors.video_mobile_upper_video_view_size = 'から最大100'

    if (!this.state.connections || this.state.connections <= 1) errors.connections = '同時接続数を入力してください'
    if (!this.state.expire) errors.expire = '有効期限を入力してください'
    if(this.state.description && this.state.description.length > 0 ) {
      if(this.state.description.length > 300)
        errors.description = '300文字以内で入力してください'
    }
    if (this.state.fvlite_auto_trial && (!this.state.expiry_days || this.state.expiry_days <= 0)) errors.expiry_days = '有効期限を入力してください'
    if (this.state.fvlite_auto_trial && (!this.state.marketing_automation_email || this.state.marketing_automation_email.length === 0)) errors.marketing_automation_email = '入力してください'
    return errors
  }
  save = (method, payload, URL, type) => {
    delete(payload['whitelisted_ip_addresses']);
    fetch(URL, {
      method: method,
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          if (method === 'POST') {
            let warning = checkJapanese() ? 'ドメインの作成に成功しました。' : 'The domain has been created successfully.';
            alert(warning)
            window.location = domainRoute
          }
          else {
            if (type === 'pc') {
              this.setState({ ...clearPCUserMedia })
            }
            else if (type === 'mobile') {
              this.setState({ ...clearMobileUserMedia })
            }
            else {
              let warning = checkJapanese() ? 'ドメインの更新に成功しました' : 'Domain renewal successful';
              alert(warning)
              window.location.reload()
            }
          }
        } else {
          if (res.errors === 'Fv domains name has already been taken') {
            let warning = checkJapanese() ? 'すでに、そのドメイン名は存在しています' : 'The domain name already exists';
            alert(warning)
          }
          else {
            res.errors.map((val, index) => (console.log(val)))
          }
        }
      })
      .catch((error) => {
        let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
        alert(warning)
      })
  }
  handleSubmit = e => {
    e.preventDefault()
    const errors = this.validate(this.state)
    this.setState({ errors })
    if (Object.keys(errors).length !== 0) {
      return
    }
    let payload = {
      ...this.state,
    }
    if (this.state.create) {
      const URL = `${APIurl}`
      const method = 'POST'
      return this.save(method, payload, URL, 'update')
    } else {
      const URL = `${APIurl}${this.props.match.params.id}`
      const method = 'PUT'
      return this.save(method, payload, URL, 'add')
    }
  }
  handleClear = (type, mediaVal) => {
    if (type === 'update') {
      const URL = `${APIurl}${this.props.match.params.id}`
      const method = 'PUT'
      return this.save(method, mediaVal === 'pc' ? clearPCUserMedia : mediaVal === 'mobile' ? clearMobileUserMedia : clearPayload, URL, mediaVal)
    }
    else {
      mediaVal === 'pc' ?
        this.setState({ ...clearPCUserMedia }) :
        mediaVal === 'mobile' ?
          this.setState({ ...clearMobileUserMedia }) :
          this.setState({ ...clearPayload })
    }
  }
  destroy = () => {
    return fetch(`${config.URI}/api/v1/domains/${this.props.match.params.id}`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          let warning = checkJapanese() ? 'ドメインの削除に成功しました' : 'Domain deleted successfully';
          alert(warning)
          window.location = '/domain'
        } else {
          res.errors.map((val, index) => (alert(val)))
        }
      })
      .catch((error) => {
        let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
        alert(warning)
      })
  }

  handleDelete = (domainId, userId) => {
    return fetch(`${config.URI}/api/v1/fvdomain/${domainId}/user/${userId}`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          let warning = checkJapanese() ? 'ドメインの削除に成功しました' : 'Domain deleted successfully';
          alert(warning)
          window.location = `/fvdomain/${domainId}`
        } else {
          res.errors.map((val, index) => (alert(val)))
        }
      })
      .catch((error) => {
        let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
        alert(warning)
      })
  }
  handleEmailClick = (e, purpose) => {
    this.setState({ emailModalOpen: true, emailModalPurpose: purpose });
  };
  handleEmailModalClose = () => this.setState({ emailModalOpen: false });

  render() {
    const { username, email, password, fvlite_role, fvdomain_id, userId } = this.state;
    const styles = {
      root: {
        'display': 'flex',
        'flexWrap': 'wrap',
        'justifyContent': 'space-around',
      },
      gridList: {
        'width': 1000,
        'height': 'auto',
        'overflowY': 'auto',
      },
      indvCell: {
        'borderRadius': 25,
      },
      floatingLabelStyle: {
        color: 'red',
      },
      floatingLabelFocusStyle: {
        color: 'black',
      },
    }
    //const uncheckedIconColor = this.state.userTypeError ? '#f44336' : '#6B7C93';
    return (
      <div className="pl3 h-100" style={{ color: '#6B7C93' }}>
        <Link to={domainRoute}>
          {'戻る(Back)'}
        </Link>
        <EmailModal
          purpose={this.state.emailModalPurpose}
          open={this.state.emailModalOpen}
          handleClose={this.handleEmailModalClose}
          fvdomainId={this.props.match.params.id}
          changeTemplate={this.props.changeTemplate}
          getExpiredUserDefaultTemplate={this.props.getExpiredUserDefaultTemplate}
          defaultData={this.props.defaultData}
          expiredMADefault={this.props.expiredMADefault}
          maData={this.props.maData}
          isUpdating={this.props.isUpdating}
          emailData={this.props.emailData}
          signupData={this.props.signupData}
          editActivationEmailTemplate={this.props.editActivationEmailTemplate}
          MASignupEmailTemplate={this.props.MASignupEmailTemplate}
        />
        <div>
          <Paper style={{ borderRight: '2px solid #e3e3e3', padding: '10px' }}>
            {this.props.match.params.id &&
              <UserTable
                {...this.props}
                handleDeleteTouch={this.handleDeleteTouch}
                handleListModalClose={this.handleListModalClose}
                handleClose={this.handleClose}
                hadleListClick={this.hadleListClick}
                editDetails={this.editDetails}
                showAdminTokenActions={true}
                handleGenApiTokenTouch={this.handleGenApiTokenTouch}
                handleRevokeApiTokenTouch={this.handleRevokeApiTokenTouch}
                max_account_number={this.state.max_account_num} />
            }
            {false && <Snackbar
              style={{ left: 200, bottom: 30 }}
              open={this.state.snackbarOpen}
              message={this.state.snackbarMessage}
              action={<FormattedMessage id="seminarActions.dismiss" />}
              onActionTouchTap={this.handleRequestClose}
              autoHideDuration={4000}
              onRequestClose={this.handleRequestClose}
            />}
            <Modal
              fetchUserDetails={this.props.fetchUserDetails}
              editUser={this.props.editUser}
              addUser={this.props.addUser}
              purpose={this.state.listModalPurpose}
              open={this.state.listModalOpen}
              handleClose={this.handleListModalClose}
              snackbarOpen={this.getSnackbarDetails}
              user={{ username, email, fvlite_role, password, fvdomain_id, userId }}
              fvdomain_id={fvdomain_id}
              errors={this.props.errors}
              success={this.props.success}
              hasServerError={this.props.hasServerError}
              msg={this.props.msg}
            />
            {/* {this.state.users && <div>
              <p><FormattedMessage id='CreateDomainLabel.totalUsers'/>: {this.state.users.length} </p>
              <Link to={`/fvdomain/${this.props.match.params.id}/user`}>Create User</Link>
               </div>} */}
            <div className="formDomain">
              {!this.state.create && this.state.fvlite_auto_trial_res && <div><FlatButton
                onTouchTap={e => this.handleEmailClick(e, 'preview')}
                backgroundColor="#ecedef"
                style={{ marginLeft: '1rem', left: '-14px', top: '42px' }}
                label={<FormattedMessage id='seminarActions.previewEmail' />}
                labelStyle={{ color: '#4688F1', fontSize: '11px' }} />
                <FlatButton
                  onTouchTap={e => this.handleEmailClick(e, 'trailExpired')}
                  backgroundColor="#ecedef"
                  style={{ marginLeft: '1rem', left: '-24px', top: '42px' }}
                  label={<FormattedMessage id='CreateDomainLabel.trailExpiredEmailBtn' />}
                  labelStyle={{ color: '#4688F1', fontSize: '11px' }} />
                <FlatButton
                  onTouchTap={e => this.handleEmailClick(e, 'trailExpiredMA')}
                  backgroundColor="#ecedef"
                  style={{ marginLeft: '1rem', top: '42px', float: 'right' }}
                  label={<FormattedMessage id='CreateDomainLabel.trailExpiredMAEmailBtn' />}
                  labelStyle={{ color: '#4688F1', fontSize: '11px' }} />
                <FlatButton
                  onTouchTap={e => this.handleEmailClick(e, 'MASignupEmail')}
                  backgroundColor="#ecedef"
                  style={{ marginLeft: '1rem', left: '10px', top: '42px', float: 'right' }}
                  label={<FormattedMessage id='CreateDomainLabel.MASignupEmailBtn' />}
                  labelStyle={{ color: '#4688F1', fontSize: '11px' }} /> </div>}

              <h4 style={{ textAlign: 'center' }}>
                {this.state.create ? <FormattedMessage id='CreateDomainLabel.formcreateTitle' /> : <FormattedMessage
                  id='CreateDomainLabel.formupdateTitle' />}
              </h4>
              <form onSubmit={this.handleSubmit}>
                <fieldset className="fieldset-design">
                  <legend className="legend-color">General Setting</legend>
                  <label style={{ textAlign: 'center', marginLeft: '35px' }}>
                    <FormattedMessage id='CreateDomainLabel.status' />
                    {this.state.status === 'expire' ? <null> {this.state.expire_flag ? '無効' : '有効'} </null> : null}
                    {this.state.status === 'valid' && '有効'}
                    {this.state.status === 'invalid' && '無効'}
                  </label>
                  <br />
                  <TextField
                    errorText={this.state.errors && this.state.errors.name && this.state.errors.name}
                    floatingLabelText={<FormattedMessage id='CreateDomainLabel.companyName' />}
                    floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                    className="inputBoxDesign"
                    name="name"
                    value={this.state.name}
                    onChange={this.handleChange}
                  />
                  <TextField
                    errorText={this.state.errors && this.state.errors.connections && this.state.errors.connections}
                    floatingLabelText={<FormattedMessage id='CreateDomainLabel.maxConnNum' />}
                    floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                    className="inputBoxDesign"
                    value={this.state.connections}
                    name="connections"
                    onChange={this.handleChange}
                  />
                  <TextField
                    className="inputBoxDesign"
                    floatingLabelText={<FormattedMessage id='CreateDomainLabel.maxRoomNumUser' />}
                    floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                    type="number"
                    name="max_room_num_per_user"
                    value={this.state.max_room_num_per_user}
                    onChange={this.handleChange}
                    errorText={this.state.errors && this.state.errors.max_room_num_per_user && this.state.errors.max_room_num_per_user}
                  />
                  <SelectField
                    selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                    floatingLabelText={<FormattedMessage id='CreateDomainLabel.contract' />}
                    value={this.state.trial}
                    name="trial"
                    onChange={(event, index, value) => this.setState({ trial: value })}
                    className="inputBoxDesign"
                  >
                    {this.menuItems(contract)}
                  </SelectField>
                  <SelectField
                    selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                    className="inputBoxDesign"
                    floatingLabelText={<FormattedMessage id='CreateDomainLabel.mode' />}
                    value={this.state.status}
                    name="status"
                    onChange={(event, index, value) => this.setState({ status: value })}
                    defaultValue="expire"
                  >
                    {this.menuItemsMode(mode)}
                  </SelectField>
                  {this.state.status === 'expire' &&
                    <DatePicker
                      hintText={<FormattedMessage id='CreateDomainLabel.expires' />} container="inline"
                      className="inputBoxDesign datepickerInput"
                      autoOk={true}
                      value={this.state.expire}
                      selected={this.state.expire}
                      name="expire"
                      onChange={(e, date) => {
                        this.setState({ expire: date })
                      }}
                      errorText={this.state.errors && this.state.errors.expire && this.state.errors.expire}
                    />
                  }
                  <div>
                    <SelectField
                      selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.fvliteAutoTrial' />}
                      value={this.state.fvlite_auto_trial}
                      name="fvlite_auto_trial"
                      onChange={(event, index, value) => this.setState({ fvlite_auto_trial: value })}
                      className="inputBoxDesign"
                      hintText="choose"
                      floatingLabelFixed={true}
                    >
                      {this.options(select, this.state.fvlite_auto_trial)}
                    </SelectField>
                    <TextField
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.limitRedirectUrl' />}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      type="url"
                      name="fvlite_auto_trial_time_limit_redirect_url"
                      value={this.state.fvlite_auto_trial_time_limit_redirect_url}
                      className="inputBoxDesign"
                      onChange={this.handleChange}
                    />
                    <TextField
                      errorText={this.state.errors && this.state.errors.expiry_days && this.state.errors.expiry_days}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.expiryDays' />}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      type="number"
                      name="expiry_days"
                      value={this.state.expiry_days}
                      className="inputBoxDesign"
                      onChange={this.handleChange}
                    />
                    <TextField
                      errorText={this.state.errors && this.state.errors.max_account_num && this.state.errors.max_account_num}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.maxAccountAmountNum' />}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      type="number"
                      name="max_account_num"
                      value={this.state.max_account_num}
                      className="inputBoxDesign"
                      onChange={this.handleChange}
                    />
                    <TextField
                      errorText={this.state.errors && this.state.errors.fv_domains_name && this.state.errors.fv_domains_name}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.FVDomainsName' />}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      className="inputBoxDesign"
                      name="fv_domains_name"
                      value={this.state.fv_domains_name}
                      onChange={this.handleChange}
                    />
                    {!this.state.create && <span>
                      {this.state.verify ? <CheckIcon color={'#26c367de'} /> : <img style={{ paddingRight: '5px' }} width="20px"
                        height="20px" src={images.error} />}
                    </span>
                    }

                    <SelectField
                      selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.FVDomainType' />}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      name="fvdomain_type"
                      value={this.state.fvdomain_type}
                      onChange={(event, index, value) => this.setState({ fvdomain_type: value })}
                      className="inputBoxDesign"
                      hintText="choose"
                      floatingLabelFixed={true}
                    >
                      {this.options(fvdomain_types, this.state.fvdomain_type)}
                    </SelectField>

                    <SelectField
                      selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.coronaCampaign' />}
                      value={this.state.campaign}
                      name="campaign"
                      onChange={(event, index, value) => this.setState({ campaign: value })}
                      className="inputBoxDesign"
                      hintText="choose"
                      floatingLabelFixed={true}
                    >
                      {this.options(select, this.state.campaign)}
                    </SelectField>

                    <SelectField
                      selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.enableIPAddressFilter' />}
                      value={this.state.enable_ipaddress_filter}
                      name="enable_ipaddress_filter"
                      onChange={(event, index, value) => this.setState({ enable_ipaddress_filter: value })}
                      className="inputBoxDesign"
                      hintText="choose"
                      floatingLabelFixed={true}
                    >
                      {this.options(select, this.state.enable_ipaddress_filter)}
                    </SelectField>
                    
                    <SelectField
                      selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.enableConferenceMode' />}
                      value={this.state.enable_conference === 1 ? true : this.state.enable_conference === 0 ? false : this.state.enable_conference }
                      name="enable_conference"
                      onChange={(event, index, value) => this.setState({ enable_conference: value })}
                      className="inputBoxDesign"
                      hintText="choose"
                      floatingLabelFixed={true}
                    >
                      {this.options(select, this.state.enable_conference)}
                    </SelectField>

                    <SelectField
                      selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.enableWebinarMode' />}
                      value={this.state.enable_webinar === 1 ? true : this.state.enable_webinar === 0 ? false : this.state.enable_webinar }
                      name="enable_webinar"
                      onChange={(event, index, value) => this.setState({ enable_webinar: value })}
                      className="inputBoxDesign"
                      hintText="choose"
                      floatingLabelFixed={true}
                    >
                      {this.options(select, this.state.enable_webinar)}
                    </SelectField>
                  </div>
                  <TextField
                    errorText={this.state.errors && this.state.errors.marketing_automation_email && this.state.errors.marketing_automation_email}
                    floatingLabelText={<FormattedMessage id='CreateDomainLabel.marketingAutomationEmail' />}
                    floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                    className="inputBoxDesign"
                    value={this.state.marketing_automation_email}
                    name="marketing_automation_email"
                    type="email"
                    onChange={this.handleChange}
                  />
                  <TextField
                    errorText={this.state.errors && this.state.errors.description && (<FormattedMessage id='createFVDomainError.discription' />) }
                    floatingLabelText={<FormattedMessage id='CreateDomainLabel.notes' />}
                    floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                    multiLine={true}
                    name="description"
                    value={this.state.description}
                    rows={2}
                    rowsMax={10}
                    onChange={this.handleChange}
                    className="inputBoxDesign"
                  />
                  {!this.state.create && <div><div>
                    <TextField
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.newadminUser' />}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      className="inputBoxDesign"
                      rows={2}
                      rowsMax={10}
                      multiLine
                      value={`${window.location.host}/signup/?type=admin&url=${this.state.url}`}
                    />
                    <TextField
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.newguestUser' />}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      className="inputBoxDesign"
                      rows={2}
                      rowsMax={10}
                      multiLine
                      value={`${window.location.host}/signup/?url=${this.state.url}`}
                    />
                  </div>
                    <div>
                      <TextField
                        floatingLabelText={<FormattedMessage id='CreateDomainLabel.newguesttrialUser' />}
                        floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                        className="inputBoxDesign w-40"
                        rows={2}
                        rowsMax={10}
                        multiLine
                        value={`${window.location.host}/trial/?url=${this.state.url}`}
                        style={{ width: '40% !important' }}
                      />
                    </div>
                  </div>
                  }

                </fieldset>
                <div>
                  <fieldset className="fieldset-design">
                    <legend className="legend-color">Admin UI/UX</legend>
                    <SelectField
                      selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.adminGuestURL' />}
                      floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                      name="admin_guest_url"
                      value={this.state.admin_guest_url}
                      onChange={(event, index, value) => this.setState({ admin_guest_url: value })}
                      className="inputBoxDesign"
                      hintText="choose"
                      floatingLabelFixed={true}
                    >
                      {this.adminGuest(select)}
                    </SelectField>
                  </fieldset>
                  <fieldset className="fieldset-design">
                    <legend className="legend-color">Video UI/UX</legend>
                    {optionInputText.map((textval, key) => {
                      return <TextField
                        errorText={this.state.errors && (this.state.video_mobile_upper_video_view_size === this.state[textval.name]) && this.state.errors.video_mobile_upper_video_view_size}
                        key={key}
                        floatingLabelText={textval.label}
                        floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                        name={textval.name}
                        value={this.state[textval.name]}
                        className="inputBoxDesign"
                        onChange={this.handleChange}
                        type={textval.type}
                      />
                    })}
                    {selectarr.map((sel, index) => {
                      return <SelectField
                        key={index}
                        selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                        floatingLabelText={sel.label}
                        value={this.state[sel.name]}
                        name={sel.name}
                        onChange={(event, index, value) => this.setState({ [sel.name]: value })}
                        className="inputBoxDesign"
                        hintText="choose"
                        floatingLabelFixed={true}
                      >
                        {this.options(select, this.state[sel.name])}
                      </SelectField>
                    })}
                    {colorInputField.map((color, index) => {
                      return <TextField
                        key={index}
                        floatingLabelText={color.label}
                        floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                        className="inputBoxcolor label-design"
                        name={color.name}
                        value={this.state[color.name]}
                        type="color"
                        onChange={this.handleChange}
                        floatingLabelFixed={true}
                      />
                    })}
                  </fieldset>
                  <fieldset className="fieldset-design">
                    <legend className="legend-color">WebRTC</legend>
                    {webRtc.map((web, index) => {
                      return <TextField
                        key={index}
                        floatingLabelText={web.label}
                        floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                        className="inputBoxDesign"
                        name={web.name}
                        value={this.state[web.name]}
                        type={web.type}
                        onChange={this.handleChange}
                      />
                    })}
                    <SelectField
                      selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.webrtcForceTurn' />}
                      value={this.state.video_webrtc_force_turn}
                      name="video_webrtc_force_turn"
                      onChange={(event, index, value) => this.setState({ video_webrtc_force_turn: value })}
                      className="inputBoxDesign"
                      hintText="choose"
                      floatingLabelFixed={true}
                    >
                      {this.options(select, this.state.video_webrtc_force_turn)}
                    </SelectField>
                    <SelectField
                      selectedMenuItemStyle={{ backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A' }}
                      floatingLabelText={<FormattedMessage id='CreateDomainLabel.videoCodec' />}
                      value={this.state.video_codec}
                      name="video_codec"
                      onChange={(event, index, value) => this.setState({ video_codec: value })}
                      className="inputBoxDesign"
                      hintText="choose"
                      floatingLabelFixed={true}
                    >
                      {this.options(video_codec, this.state.video_codec)}
                    </SelectField>
                  </fieldset>
                  <fieldset className="fieldset-design">
                    <legend className="legend-color">PC getUserMedia Option(set all if you want to set)</legend>
                    {pcGetUserMedia.map((media, index) => {
                      return <TextField
                        key={index}
                        floatingLabelText={media.label}
                        floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                        className="inputBoxDesign"
                        name={media.name}
                        value={this.state[media.name]}
                        type={media.type}
                        onChange={this.handleChange}
                      />
                    })}
                    <FlatButton type="reset" onClick={(e) => this.handleClear(this.state.create ? 'add' : 'update', 'pc', e)}
                      style={{ marginLeft: '10px' }} style={{ position: 'relative', float: 'right' }} label={<FormattedMessage id="CreateDomainLabel.resetBtn" />}
                      backgroundColor="#3fab7a" labelStyle={{ color: '#FFFFFF' }} />
                  </fieldset>
                  <fieldset className="fieldset-design">
                    <legend className="legend-color">Mobile Get User Media(set all if you want to set)</legend>
                    {mobileGetUserMedia.map((mobile, index) => {
                      return <TextField
                        key={index}
                        floatingLabelText={mobile.label}
                        floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                        className="inputBoxDesign"
                        name={mobile.name}
                        value={this.state[mobile.name]}
                        type={mobile.type}
                        onChange={this.handleChange}
                      />
                    })}
                    <FlatButton type="reset" onClick={(e) => this.handleClear(this.state.create ? 'add' : 'update', 'mobile', e)}
                      style={{ marginLeft: '10px' }} style={{ position: 'relative', float: 'right' }} label={<FormattedMessage id="CreateDomainLabel.resetBtn" />}
                      backgroundColor="#3fab7a" labelStyle={{ color: '#FFFFFF' }} />
                  </fieldset>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginTop: '10px' }}>
                  {this.state.create ? <FlatButton type="submit"
                    label={<FormattedMessage id="CreateDomainLabel.createBtn" />}
                    backgroundColor="#3fab7a" labelStyle={{ color: '#FFFFFF' }} /> :
                    <FlatButton type="submit" label={<FormattedMessage id="CreateDomainLabel.updateBtn" />}
                      backgroundColor="#3fab7a" labelStyle={{ color: '#FFFFFF' }} />}

                  <FlatButton type="reset" onClick={(e) => this.handleClear(this.state.create ? 'add' : 'update', '', e)}
                    style={{ marginLeft: '10px' }} label={<FormattedMessage id="CreateDomainLabel.resetBtn" />}
                    backgroundColor="#3fab7a" labelStyle={{ color: '#FFFFFF' }} />
                </div>
              </form>
            </div>
            {false && <button onClick={() => this.destroy()}>
              ドメインの削除を行う(Delete this domain)
            </button>}
          </Paper>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingList: state.users.isFetchingList,
    users: state.users.users,
    errors: state.users.errors,
    success: state.users.success,
    hasServerError: state.users.hasServerError,
    domainId: state.loginLayout.user.fvdomain_id,
    msg: state.users.msg,
    redirectToLogin: state.loginLayout.redirectToLogin,
    tokenVerified: state.loginLayout.tokenVerified,
    isLoggedIn: state.login.isLoggedIn,
    open: state.loginLayout.open,
    isUpdating: state.templateReducer.isUpdating,
    defaultData: state.templateReducer.data,
    maData: state.templateReducer.maData,
    emailData: state.templateReducer.emailData,
    signupData: state.templateReducer.signupData,
    domains: state.templateReducer.data,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  fetchUserList: (token, id) => dispatch(userAction.fetchUserList(token, id)),
  addUser: (token, payload) => dispatch(userAction.addUser(token, payload)),
  editUser: (token, payload, id) => dispatch(userAction.editUser(token, payload, id)),
  deleteUser: (token, id, fvdomain_id) => dispatch(userAction.deleteUser(token, id, fvdomain_id)),
  genApiTokenUser: (token, id, fvdomain_id) => dispatch(userAction.genApiTokenUser(token, id, fvdomain_id)),
  revokeApiTokenUser: (token, id, fvdomain_id) => dispatch(userAction.revokeApiTokenUser(token, id, fvdomain_id)),
  clearErrors: () => dispatch(userAction.clearErrors()),
  returnUserIfUserExists: token => dispatch(actions.returnUserIfUserExists(token)),
  checkValidity: token => dispatch(actions.checkValidity(token)),
  checkTokenOnPathChange: token => dispatch(actions.checkTokenOnPathChange(token)),
  changeTemplate: (id, payload) => dispatch(template.changeTemplate(id, payload)),
  getExpiredUserDefaultTemplate: (id) => dispatch(template.getExpiredUserDefaultTemplate(id)),
  expiredMADefault: (id) => dispatch(template.expiredMADefault(id)),
  editActivationEmailTemplate: (id) => dispatch(template.editActivationEmailTemplate(id)),
  MASignupEmailTemplate: (id) => dispatch(template.MASignupEmailTemplate(id)),
  getSingleDomainData: (id) => dispatch(template.getSingleDomainData(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(authenticate(Domain)))


// WEBPACK FOOTER //
// src/routes/Domain/create.js